/* =========================================================
   Kalva Home — theme scripts (no dependencies)
   ========================================================= */
(function () {
  'use strict';
  var K = window.Kalva || {};
  var S = K.strings || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var productsRoot = (K.routes && K.routes.root ? K.routes.root : '/').replace(/\/$/, '') + '/products/';

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || K.moneyFormat || '£{{amount}}';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        default: return fmt(cents, 2);
      }
    });
  }
  K.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, link, linkText) {
    var el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = '';
    var span = document.createElement('span'); span.textContent = msg; el.appendChild(span);
    if (link) { var a = document.createElement('a'); a.href = link; a.textContent = linkText; el.appendChild(a); }
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2800);
  }

  /* ---------- Overlay / panels / modals ---------- */
  var openLayer = null;
  function lock(on) { document.body.classList.toggle('k-lock', !!on); }
  function openPanel(el, trigger) {
    if (!el) return;
    closeAll();
    el.hidden = false;
    var ov = el.querySelector('[data-overlay]') || el.previousElementSibling;
    requestAnimationFrame(function () { el.classList.add('is-open'); var p = el.querySelector('.k-panel, .k-menu-drawer'); if (p) p.classList.add('is-open'); });
    openLayer = { el: el, trigger: trigger };
    lock(true);
    var focusable = el.querySelector('[data-autofocus], button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeLayer() {
    if (!openLayer) return;
    var el = openLayer.el, trigger = openLayer.trigger;
    el.classList.remove('is-open');
    var p = el.querySelector('.k-panel, .k-menu-drawer'); if (p) p.classList.remove('is-open');
    setTimeout(function () { el.hidden = true; }, 250);
    lock(false);
    openLayer = null;
    if (trigger && trigger.focus) trigger.focus();
  }
  function closeDisclosures(except) {
    $$('[data-disclosure][aria-expanded="true"]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var t = document.getElementById(b.getAttribute('aria-controls')); if (t) t.hidden = true;
    });
  }
  function closeAll() { closeDisclosures(); if (openLayer) closeLayer(); }
  K.openPanel = openPanel; K.closeLayer = closeLayer;

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openPanel(document.getElementById(opener.getAttribute('data-open')), opener);
      return;
    }
    if (t.closest('[data-close]')) { e.preventDefault(); closeLayer(); return; }
    var disc = t.closest('[data-disclosure]');
    if (disc) {
      var target = document.getElementById(disc.getAttribute('aria-controls'));
      var open = disc.getAttribute('aria-expanded') === 'true';
      closeDisclosures(disc);
      disc.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (target) target.hidden = open;
      return;
    }
    if (!t.closest('[data-disclosure-panel]')) closeDisclosures();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- Announcement bar ---------- */
  $$('[data-ann]').forEach(function (bar) {
    var msgs = $$('.k-ann__msg', bar); if (msgs.length < 2) return;
    var i = 0, timer;
    function show(n) { msgs[i].classList.remove('is-active'); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('is-active'); }
    function auto() { clearInterval(timer); var s = parseInt(bar.getAttribute('data-interval'), 10); if (s > 0) timer = setInterval(function () { show(i + 1); }, s * 1000); }
    var prev = $('[data-ann-prev]', bar), next = $('[data-ann-next]', bar);
    if (prev) prev.addEventListener('click', function () { show(i - 1); auto(); });
    if (next) next.addEventListener('click', function () { show(i + 1); auto(); });
    auto();
  });

  /* ---------- Localization (country / language) ---------- */
  $$('form.k-locale-form').forEach(function (form) {
    $$('[data-locale-value]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = form.querySelector('input[name="' + btn.getAttribute('data-locale-input') + '"]');
        if (input) { input.value = btn.getAttribute('data-locale-value'); form.submit(); }
      });
    });
  });

  /* ---------- Mobile menu accordions ---------- */
  $$('[data-mm-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      var t = document.getElementById(b.getAttribute('aria-controls')); if (t) t.hidden = open;
    });
  });

  /* ---------- Cart ---------- */
  function cartDrawer() { return document.getElementById('CartDrawer'); }
  function renderCart(html) {
    var drawer = cartDrawer(); if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawerInner');
    var cur = document.getElementById('CartDrawerInner');
    if (fresh && cur) {
      cur.replaceWith(fresh);
      var count = fresh.getAttribute('data-item-count') || '0';
      $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.setAttribute('data-count', count); });
    }
  }
  function cartRequest(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { if (j.sections) renderCart(j.sections['cart-drawer']); return j; });
  }
  function openCart(trigger) {
    var d = cartDrawer(); if (!d) return false;
    openPanel(d, trigger); return true;
  }
  K.openCart = openCart;
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-cart-open]');
    if (c && cartDrawer() && K.cartType !== 'page' && document.body.className.indexOf('template-cart') === -1) { e.preventDefault(); openCart(c); }
  });
  // add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || !cartDrawer() || K.cartType === 'page') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    var body = { items: [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }] };
    cartRequest(K.routes.cartAdd + '.js', body)
      .then(function () { openCart(btn); })
      .catch(function (err) { toast((err && (err.description || err.message)) || S.unavailable); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });
  // quick add (wishlist, upsell)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    cartRequest(K.routes.cartAdd + '.js', { items: [{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }] })
      .then(function () { if (K.cartType === 'page') { window.location.href = K.routes.cart; return; } if (!openLayer || openLayer.el !== cartDrawer()) openCart(b); })
      .catch(function (err) { toast((err && err.description) || S.unavailable); })
      .then(function () { b.disabled = false; });
  });
  // change quantity / remove (drawer)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    var line = parseInt(b.getAttribute('data-line'), 10);
    var qty = parseInt(b.getAttribute('data-line-change'), 10);
    var onCartPage = document.body.className.indexOf('template-cart') > -1;
    cartRequest(K.routes.cartChange + '.js', { line: line, quantity: qty })
      .then(function () { if (onCartPage) window.location.reload(); })
      .catch(function (err) { toast((err && err.description) || S.unavailable); });
  });

  /* ---------- Wishlist ---------- */
  var WKEY = 'kalva:wishlist';
  function wishList() { return store.get(WKEY, []); }
  function syncWish() {
    var list = wishList();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var title = b.getAttribute('data-title') || '';
      if (b.hasAttribute('data-label-add')) b.setAttribute('aria-label', on ? b.getAttribute('data-label-remove') : b.getAttribute('data-label-add'));
    });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length; c.setAttribute('data-count', list.length); });
    $$('[data-wish-link]').forEach(function (a) { a.hidden = !list.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-handle'), title = b.getAttribute('data-title') || '';
    var list = wishList(), idx = list.indexOf(h);
    if (idx > -1) { list.splice(idx, 1); toast(title + ' ' + S.wishRemoved); }
    else { list.unshift(h); toast(title + ' ' + S.wishAdded, K.wishlistUrl, S.viewWishlist); }
    store.set(WKEY, list);
    syncWish();
    var page = $('[data-wishlist-page]'); if (page && idx > -1) renderWishlistPage(page);
  });
  function renderWishlistPage(page) {
    var params = new URLSearchParams(window.location.search);
    var shared = params.get('items');
    var handles = shared ? shared.split(',').filter(Boolean) : wishList();
    var grid = $('[data-wishlist-grid]', page), empty = $('[data-wishlist-empty]', page), count = $('[data-wishlist-count]', page), share = $('[data-wishlist-share]', page);
    var tpl = $('template[data-wishlist-card]', page);
    if (count) count.textContent = handles.length === 1 ? page.getAttribute('data-one') : page.getAttribute('data-other').replace('[count]', handles.length);
    if (empty) empty.hidden = handles.length > 0;
    if (share) share.hidden = handles.length === 0;
    grid.innerHTML = '';
    handles.forEach(function (h) {
      fetch(productsRoot + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p || !tpl) return;
        var node = tpl.content.cloneNode(true);
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        $$('[data-w-link]', node).forEach(function (a) { a.href = p.url; });
        var img = $('[data-w-img]', node);
        if (img && p.featured_image) { img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600'; img.alt = p.title; } else if (img) img.remove();
        $('[data-w-title]', node).textContent = p.title;
        $('[data-w-type]', node).textContent = p.type || p.vendor || '';
        $('[data-w-price]', node).textContent = formatMoney(v.price);
        var was = $('[data-w-was]', node); if (v.compare_at_price && v.compare_at_price > v.price) was.textContent = formatMoney(v.compare_at_price); else was.remove();
        var heart = $('[data-wish]', node); heart.setAttribute('data-handle', p.handle); heart.setAttribute('data-title', p.title);
        var add = $('[data-quick-add]', node);
        if (v.available) add.setAttribute('data-quick-add', v.id); else { add.disabled = true; add.textContent = S.soldOut; }
        grid.appendChild(node);
        syncWish();
      });
    });
  }
  $$('[data-wishlist-page]').forEach(renderWishlistPage);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-share]');
    if (!b) return;
    var url = window.location.origin + window.location.pathname + '?items=' + wishList().join(',');
    if (navigator.share) { navigator.share({ url: url }).catch(function () {}); }
    else if (navigator.clipboard) { navigator.clipboard.writeText(url).then(function () { toast(S.linkCopied); }); }
  });
  syncWish();

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = $('script[data-product-json]', root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('form[data-product-form]', root);
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceNow = $('[data-price-now]', root), priceWas = $('[data-price-was]', root), priceOff = $('[data-price-off]', root), badge = $('[data-save-badge]', root);
    var atc = $('[data-atc]', root), stickyAtc = $('[data-sticky-atc] [data-sticky-price]');
    function currentOptions() {
      return $$('.k-opt', root).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
    }
    function update() {
      var opts = currentOptions();
      var v = product.variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      $$('.k-opt', root).forEach(function (fs, i) { var l = fs.querySelector('[data-opt-selected]'); if (l) l.textContent = opts[i] || ''; });
      if (!v) { if (atc) { atc.disabled = true; atc.textContent = S.unavailable; } return; }
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = formatMoney(v.price);
      if (stickyAtc) stickyAtc.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceWas) { priceWas.hidden = !onSale; if (onSale) priceWas.textContent = formatMoney(v.compare_at_price); }
      if (priceOff) { priceOff.hidden = !onSale; if (onSale) priceOff.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      if (badge) { badge.hidden = !onSale; if (onSale) badge.textContent = badge.getAttribute('data-template').replace('[amount]', formatMoney(v.compare_at_price - v.price)); }
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? S.addToCart : S.soldOut; }
      if (window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
      if (v.featured_media) {
        var slide = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide && window.innerWidth < 900 && slide.parentElement.classList.contains('k-slider')) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }
    $$('.k-opt input', root).forEach(function (i) { i.addEventListener('change', update); });
    // quantity
    $$('[data-qty]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      $('[data-qty-dec]', wrap).addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      $('[data-qty-inc]', wrap).addEventListener('click', function () { input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1); });
    });
    // slider dots
    var slider = $('.k-slider', root), dots = $$('.k-slider__dots button', root);
    if (slider && dots.length) {
      slider.addEventListener('scroll', function () {
        var i = Math.round(slider.scrollLeft / slider.clientWidth);
        dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }, { passive: true });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { slider.scrollTo({ left: n * slider.clientWidth, behavior: 'smooth' }); }); });
    }
    // sticky add to cart (phone)
    var sticky = $('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0); }).observe(atc);
      var sBtn = $('button', sticky);
      if (sBtn) sBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else atc.click(); });
    }
    // recently viewed
    var rv = store.get('kalva:recent', []).filter(function (h) { return h !== product.handle; });
    rv.unshift(product.handle); store.set('kalva:recent', rv.slice(0, 12));
  });

  /* ---------- Delivery estimate ---------- */
  function addWorkingDays(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; }
  $$('[data-delivery]').forEach(function (el) {
    var lang = document.documentElement.lang || 'en-GB'; if (lang === 'en') lang = 'en-GB';
    var o = { weekday: 'short', day: 'numeric', month: 'short' };
    var min = addWorkingDays(new Date(), parseInt(el.getAttribute('data-min') || K.deliveryMin || 4, 10));
    var max = addWorkingDays(new Date(), parseInt(el.getAttribute('data-max') || K.deliveryMax || 7, 10));
    el.innerHTML = el.getAttribute('data-template').replace('[min]', min.toLocaleDateString(lang, o)).replace('[max]', max.toLocaleDateString(lang, o));
  });

  /* ---------- Size guide calculator ---------- */
  $$('[data-guide-calc]').forEach(function (c) {
    var r = $('input[type=range]', c), w = $('[data-table-w]', c), a = $('[data-d-min]', c), b = $('[data-d-max]', c);
    function upd() { var v = parseInt(r.value, 10); w.textContent = v; a.textContent = Math.round(v * 0.5); b.textContent = Math.round(v * 0.66); }
    r.addEventListener('input', upd); upd();
  });

  /* ---------- Recently viewed ---------- */
  $$('[data-recent]').forEach(function (sec) {
    var current = sec.getAttribute('data-current');
    var list = store.get('kalva:recent', []).filter(function (h) { return h !== current; }).slice(0, parseInt(sec.getAttribute('data-limit') || '4', 10));
    var grid = $('[data-recent-grid]', sec), tpl = $('template', sec);
    if (!list.length || !grid || !tpl) return;
    var done = 0;
    list.forEach(function (h) {
      fetch(productsRoot + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        done++;
        if (p) {
          var n = tpl.content.cloneNode(true);
          $('a', n).href = p.url;
          var img = $('img', n); if (p.featured_image) { img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200'; img.alt = p.title; } else img.remove();
          $('[data-r-title]', n).textContent = p.title;
          $('[data-r-price]', n).textContent = formatMoney(p.price);
          grid.appendChild(n);
        }
        if (done === list.length && grid.children.length) sec.hidden = false;
      });
    });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (sec) {
    if (sec.children.length) return;
    fetch(sec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var n = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
      if (n && n.innerHTML.trim()) { sec.innerHTML = n.innerHTML; syncWish(); }
    }).catch(function () {});
  });

  /* ---------- Hero video ---------- */
  $$('[data-hero-video]').forEach(function (wrap) {
    var v = $('video', wrap.closest('.k-hero')), b = $('[data-hero-play]', wrap.closest('.k-hero'));
    if (!v || !b) return;
    b.addEventListener('click', function () {
      if (v.paused) { v.play(); b.setAttribute('aria-label', b.getAttribute('data-pause')); b.innerHTML = b.getAttribute('data-icon-pause'); }
      else { v.pause(); b.setAttribute('aria-label', b.getAttribute('data-play')); b.innerHTML = b.getAttribute('data-icon-play'); }
    });
  });

  /* ---------- Pop-up ---------- */
  $$('[data-popup]').forEach(function (pop) {
    var key = 'kalva:popup:' + (pop.getAttribute('data-popup') || 'v1');
    var success = pop.hasAttribute('data-success');
    function show() { openPanel(pop); }
    function dismiss() { store.set(key, Date.now()); }
    pop.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) dismiss(); });
    if (success) { show(); dismiss(); return; }
    var last = store.get(key, 0);
    var days = parseInt(pop.getAttribute('data-days') || '30', 10);
    if (window.Shopify && Shopify.designMode) return;
    if (last && Date.now() - last < days * 864e5) return;
    setTimeout(function () { if (!openLayer) show(); }, parseInt(pop.getAttribute('data-delay') || '6', 10) * 1000);
  });
  document.addEventListener('shopify:section:select', function (e) { var p = $('[data-popup]', e.target); if (p) openPanel(p); });
  document.addEventListener('shopify:section:deselect', function (e) { if ($('[data-popup]', e.target)) closeLayer(); });

  /* ---------- Collection filters & sort ---------- */
  $$('form[data-filter-form]').forEach(function (form) {
    function go() {
      var fd = new FormData(form), params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      window.location.search = params.toString();
    }
    form.addEventListener('change', function (e) { if (e.target.type !== 'number') go(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
  });
  $$('select[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
  });
  $$('[data-filters-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { var f = document.getElementById(b.getAttribute('aria-controls')); var open = b.getAttribute('aria-expanded') === 'true'; b.setAttribute('aria-expanded', open ? 'false' : 'true'); f.classList.toggle('is-open', !open); });
  });

  /* ---------- View in my room ---------- */
  var isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-room-open]');
    if (!b) return;
    e.preventDefault();
    var canCamera = navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
    if (isTouch && canCamera) openRoom(b);
    else openPanel(document.getElementById(b.getAttribute('data-qr')), b);
  });
  function openRoom(b) {
    var st = { cx: window.innerWidth / 2, top: Math.round(window.innerHeight * 0.18), size: 100, drag: null, stream: null };
    var baseW = Math.min(220, window.innerWidth * 0.5);
    var el = document.createElement('div');
    el.className = 'k-room'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', b.getAttribute('data-title'));
    el.innerHTML =
      '<video playsinline muted autoplay></video>' +
      '<div class="k-room__cable" aria-hidden="true"></div>' +
      '<button type="button" class="k-room__item" aria-label="' + b.getAttribute('data-title') + '"><img src="' + b.getAttribute('data-img') + '" alt="" crossorigin="anonymous"></button>' +
      '<div class="k-room__top"><button type="button" class="k-room__round" data-room-close aria-label="' + (b.getAttribute('data-close-label') || 'Close') + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="k-room__chip"><span></span><span>·</span><span></span></div>' +
      '<button type="button" class="k-room__round" data-room-reset aria-label="' + b.getAttribute('data-reset') + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v4h4"/></svg></button></div>' +
      '<div class="k-room__hint" role="status"></div>' +
      '<div class="k-room__sheet"><div class="k-room__size"><label for="kRoomSize" class="k-label" style="margin:0">' + b.getAttribute('data-size') + '</label><input id="kRoomSize" type="range" min="40" max="180" value="100"><span data-room-pct>100%</span></div>' +
      '<div class="k-room__actions"><button type="button" class="k-room__shutter" data-room-shot aria-label="' + b.getAttribute('data-shot') + '"><span></span></button>' +
      '<button type="button" class="k-btn" data-room-add>' + S.addToCart + '</button></div>' +
      '<p class="k-muted" style="margin-top:12px;font-size:11px;text-align:center">' + b.getAttribute('data-disclaimer') + '</p></div>';
    document.body.appendChild(el); lock(true);
    var chip = $$('.k-room__chip span', el); chip[0].textContent = b.getAttribute('data-title'); chip[2].textContent = b.getAttribute('data-price');
    $('.k-room__hint', el).textContent = b.getAttribute('data-hint');
    var video = $('video', el), item = $('.k-room__item', el), cable = $('.k-room__cable', el), img = $('img', item), range = $('input', el);
    function layout() {
      var w = baseW * st.size / 100;
      item.style.width = w + 'px'; item.style.left = (st.cx - w / 2) + 'px'; item.style.top = st.top + 'px';
      cable.style.left = (st.cx - 1) + 'px'; cable.style.height = (st.top + 4) + 'px';
      $('[data-room-pct]', el).textContent = st.size + '%';
    }
    layout();
    navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } }, audio: false }).then(function (s) { st.stream = s; video.srcObject = s; })
      .catch(function () { var er = document.createElement('div'); er.className = 'k-room__error'; er.textContent = b.getAttribute('data-denied'); el.appendChild(er); });
    item.addEventListener('pointerdown', function (e) { st.drag = { x: e.clientX, y: e.clientY, cx: st.cx, top: st.top }; item.setPointerCapture(e.pointerId); $('.k-room__hint', el).hidden = true; });
    item.addEventListener('pointermove', function (e) { if (!st.drag) return; st.cx = Math.max(20, Math.min(window.innerWidth - 20, st.drag.cx + e.clientX - st.drag.x)); st.top = Math.max(60, Math.min(window.innerHeight * 0.7, st.drag.top + e.clientY - st.drag.y)); layout(); });
    item.addEventListener('pointerup', function () { st.drag = null; });
    range.addEventListener('input', function () { st.size = parseInt(range.value, 10); layout(); });
    $('[data-room-reset]', el).addEventListener('click', function () { st.cx = window.innerWidth / 2; st.top = Math.round(window.innerHeight * 0.18); st.size = 100; range.value = 100; layout(); });
    function close() { if (st.stream) st.stream.getTracks().forEach(function (t) { t.stop(); }); el.remove(); lock(false); b.focus(); }
    $('[data-room-close]', el).addEventListener('click', close);
    $('[data-room-add]', el).addEventListener('click', function () {
      close();
      var f = document.querySelector('form[data-product-form]');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
    });
    $('[data-room-shot]', el).addEventListener('click', function () {
      try {
        var c = document.createElement('canvas'), vw = video.videoWidth, vh = video.videoHeight;
        c.width = el.clientWidth * 2; c.height = el.clientHeight * 2;
        var ctx = c.getContext('2d'), scale = Math.max(c.width / vw, c.height / vh);
        if (vw) ctx.drawImage(video, (c.width - vw * scale) / 2, (c.height - vh * scale) / 2, vw * scale, vh * scale);
        ctx.fillStyle = '#1A1A1A'; ctx.fillRect((st.cx - 1) * 2, 0, 4, (st.top + 4) * 2);
        var w = baseW * st.size / 100, h = w * (img.naturalHeight / img.naturalWidth || 1);
        ctx.drawImage(img, (st.cx - w / 2) * 2, st.top * 2, w * 2, h * 2);
        c.toBlob(function (blob) {
          var file = new File([blob], 'kalva-room.jpg', { type: 'image/jpeg' });
          if (navigator.canShare && navigator.canShare({ files: [file] })) navigator.share({ files: [file] }).catch(function () {});
          else { var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'kalva-room.jpg'; a.click(); }
        }, 'image/jpeg', 0.9);
      } catch (err) {}
    });
  }
})();

/* Gallery filters — work across every gallery section of the page */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gal-filter]');
    if (!b) return;
    var v = b.getAttribute('data-gal-filter');
    document.querySelectorAll('[data-gal-filter]').forEach(function (x) {
      var on = x.getAttribute('data-gal-filter') === v;
      x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-gal-item]').forEach(function (it) {
      it.hidden = !(v === 'all' || it.getAttribute('data-cat') === v);
    });
  });
})();

/* Track my order: open the carrier tracking site with the number */
(function () {
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-track-form]');
    if (!f) return;
    e.preventDefault();
    var n = (f.querySelector('[name="number"]').value || '').trim().replace(/\s+/g, '');
    if (!n) return;
    var url = (f.getAttribute('data-pattern') || 'https://t.17track.net/en#nums=[number]').replace('[number]', encodeURIComponent(n));
    window.open(url, '_blank', 'noopener');
  });
})();
